<template>
  <div>
    <div class="level">
      <div class="level-left">
        <div class="level-item">
          <div>
            <h4 class="title is-4">{{ title }}</h4>
            <h6 class="title is-6" v-if="submissions.length">Count: {{ submissions.length }}</h6>
          </div>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <button class="button" @click="exportData(exportUrl)">
            Export
          </button>
        </div>
        <div class="level-item" v-if="submissions.length">
          <button class="button" v-if="listVisible" @click="listVisible = !listVisible">
            Hide List of Submissions
          </button>
          <button class="button" v-if="!listVisible" @click="listVisible = !listVisible">
            Show List of Submissions
          </button>
        </div>
      </div>
    </div>
    <table class="table" v-if="submissions.length && listVisible">
      <thead>
        <tr>
          <th>Name</th>
          <th>Email</th>
          <th>Completed Evaluations</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="submission in submissions" :key="submission.id">
          <td>{{ submission.fullName }}</td>
          <td>{{ submission.email }}</td>
          <td>{{ submission.numCompletedEvaluations }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import moment from 'moment'

import Report from '@/services/reports'

export default {
  name: 'ReportLoader',
  props: {
    title: {
      type: String,
      default: '',
    },
    submissions: {
      type: Array,
      default: () => [],
    },
    exportUrl: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      listVisible: false,
    }
  },
  methods: {
    exportData(exportURL) {
      console.log("exportData-submissionloader")
      Report.api
        .retrieveExport(exportURL)
        .then(response => {
          console.log("response-submissionloader")
          this.$Alert.alert({
            type: 'success',
            message: `Export Successful`,
            timeout: 6000,
          })
        })
        .catch(err => {
          console.log("catch")
          this.$Alert.alert({
            type: 'error',
            message: `Export Failed`,
            timeout: 6000,
          })
        })

    },
    
  },
}
</script>

<style lang="scss" scoped></style>
